export enum CardFormat {
    Image = 'Image',
    List = 'List',
    Full = 'Full'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/constants/cardFormats.ts